import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Fenxiang4 = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb4d1__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb4d1__a)">
            <path
              fillRule="evenodd"
              d="m32.841 6.013 7.56 7.56a2.031 2.031 0 0 1 0 2.854l-7.56 7.56a2.028 2.028 0 0 1-2.875-.02c-.781-.782-.751-2.01.03-2.791l3.914-3.915c-5.597.582-10.583 2.101-14.465 4.225-4.074 2.228-6.738 4.998-7.85 7.887-.397 1.03-1.408 1.784-2.501 1.625l-.033-.005c-1.093-.159-1.822-1.153-1.496-2.208 1.37-4.447 5.11-8.155 9.96-10.809 4.615-2.523 10.44-4.22 16.846-4.777l-4.368-4.368a2.016 2.016 0 0 1 .008-2.841c.76-.76 2.05-.758 2.83.023M10 39v-4H6v8h36v-8h-4v4H10Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
